import type { InjectionKey } from 'vue';
import type { Breakpoints as BreakpointsConfig } from 'vue3-mq';

export interface Breakpoints {
    current: string;
    xs: boolean;
    smMinus: boolean;
    smPlus: boolean;
    sm: boolean;
    mdMinus: boolean;
    mdPlus: boolean;
    md: boolean;
    lgMinus: boolean;
    lgPlus: boolean;
    lg: boolean;
    xlMinus: boolean;
    xlPlus: boolean;
    xl: boolean;
    xxl: boolean;
    orientation: string;
    isLandscape: boolean;
    isPortrait: boolean;
    theme: string;
    isDark: boolean;
    isLight: boolean;
    motionPreference: string;
    isMotion: boolean;
    isInert: boolean;
}

export const breakpoints: BreakpointsConfig = {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1366,
    xxl: 1600,
};

export const mediaQueriesInjectionKey: InjectionKey<Breakpoints> = 'mq' as any;
export const defaultBreakpoints: Breakpoints = {
    current: '_missing',
    xs: false,
    smMinus: false,
    smPlus: false,
    sm: false,
    mdMinus: false,
    mdPlus: false,
    md: false,
    lgMinus: false,
    lgPlus: false,
    lg: false,
    xlMinus: false,
    xlPlus: false,
    xl: false,
    xxl: false,
    orientation: '',
    isLandscape: false,
    isPortrait: false,
    theme: '',
    isDark: false,
    isLight: false,
    motionPreference: '',
    isMotion: false,
    isInert: false,
};
